module.exports = __webpack_public_path__ + "static/media/gradientRight.0d9c2151.png";